import React, { useState, useEffect } from 'react'
import "./recieved.css";
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Papa from 'papaparse';
import html2pdf from 'html2pdf.js'
export const Recived_orders = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalShow1, setModalShow1] = useState(false);
  const [searchvalue, setsearchvalue] = useState("")
  const [order, setorder] = useState([])
  const [originalOrder, setoriginalOrder] = useState([]) 
  const [startDate, setstartDate] = useState("")
  const [endDate, setendDate] = useState("")
  const [startTime, setstartTime] = useState("")
  const [endTime, setendTime] = useState("")
  const [paymentMode, setpaymentMode] = useState("")
  const [index, setindex] = useState(0)
  const [id, setid] = useState(null)
  const [lgShow2, setLgShow2] = useState(false);
  const getreceivedorder = async () => {
    try {
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminGetOrder`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        }
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          setorder(response.data)
          setoriginalOrder(response.data) 

        } else {
          toast.error("No Order Found")

        }
      })
    } catch (error) {
      console.error('API Error:', error);
    }

  }
  const updateorder = async (status) => {
    try {
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminUpdateOrderStatus`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          OrderId: id,
          OrderConfirmedStatus: status
        })
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          toast.success("Order Received Successfully")
          getreceivedorder()
          setModalShow(false)
          setindex(null)
          setid(null)
        } else {
          toast.error("Something Went Wrong")

        }
      })
    } catch (error) {
      console.error('API Error:', error);
    }

  }
  const updateshippedorder = async (status, orderid) => {
    try {
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminUpdateOrderStatus`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          OrderId: orderid,
          OrderConfirmedStatus: status
        })
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          toast.success("Order Shipped Successfully")
          getreceivedorder()
          setindex(null)
          setid(null)
          
        } else {
          toast.error("Something Went Wrong")

        }
      })
    } catch (error) {
      console.error('API Error:', error);
    }
  }
  useEffect(() => {
    getreceivedorder()
  }, [])

  const convertToCSV = (data) => {


    const transformedData = data.map((item) => {
      let totalQuantity = 0;
      let totalSubTotal = 0;
      item.OrderDetail.forEach((orderDetailItem) => {
        totalQuantity += parseInt(orderDetailItem.OrderQuantity);
        totalSubTotal += parseInt(orderDetailItem.OrderSubTotal);
      });
      return (
        {
          "Order ID": item.OrderId,
          "Product Name": item.OrderDetail[0].OrderName + (item.OrderDetail.length > 1 ? "+ " + parseInt(item.OrderDetail.length - 1) : ""),
          "Buyer": item.OrderAddress?.[0]?.Phone.replace('+91', ''),
          "Date": item.OrderDate.split(" ")[0],
          "Time": item.OrderDate.split(" ")[1],
          "Quantity": totalQuantity,
          "Payment": "COD",
          "Amount": totalSubTotal,
          "Coupon": "",
        })
    });

    // Generate CSV from transformed data
    const csv = Papa.unparse(transformedData, {
      header: true, // Include headers in CSV
    });

    return csv;
  };
  const downloadCSV = (csvData, fileName) => {
    const blob = new Blob([csvData], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleExportCSV = () => {
    // Export only the currently filtered/displayed data
    const csvData = convertToCSV(order);
    downloadCSV(csvData, 'order_data.csv');
  };



  const search = async () => {
    if (searchvalue.length > 0) {
      const filteredData = originalOrder.filter((item) => {
        const orderId = item.OrderId;
        const phone = item.UserPhone;
        return orderId.includes(searchvalue) || phone.includes(searchvalue)
      })
      setorder(filteredData)
      setCurrentPage(1)
    } else {
      // Reset to original data when search input is empty
      setorder(originalOrder)
      setCurrentPage(1)
    }
  }


  const filter = async () => {
    // Start with original data or filtered by search if search is active
    let dataToFilter = searchvalue.length > 0 ? 
      originalOrder.filter((item) => {
        const orderId = item.OrderId;
        const phone = item.UserPhone;
        return orderId.includes(searchvalue) || phone.includes(searchvalue)
      }) : 
      [...originalOrder];

    const filteredData = dataToFilter.filter((item) => {
      const orderDate = item.OrderDate.split(" ")[0];
      const orderTime = item.OrderDate.split(" ")[1];
      const payment = item.OrderPaymentType;
      var dateString = orderDate;

      // Split the date string into day, month, and year
      var dateParts = dateString.split("-");
      var day = parseInt(dateParts[0], 10);
      var month = parseInt(dateParts[1], 10) - 1; // Adjust month (0-indexed in JavaScript)
      var year = parseInt(dateParts[2], 10);

      // Create a new Date object with the parsed values
      var myDate = new Date(year, month, day);
      console.log(startDate, endDate, startTime, endTime, paymentMode);
      if (startDate.length > 0 && endDate.length > 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && orderTime >= startTime && orderTime <= endTime && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && orderTime >= startTime && orderTime <= endTime
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && orderTime >= startTime && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && orderTime >= startTime
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && orderTime <= endTime && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && orderTime <= endTime
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate)
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && orderTime >= startTime && orderTime <= endTime && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && orderTime >= startTime && orderTime <= endTime
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && orderTime >= startTime && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && orderTime >= startTime
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && orderTime <= endTime && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && orderTime <= endTime
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate)
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length > 0) {
        return myDate <= new Date(endDate) && orderTime >= startTime && orderTime <= endTime && payment.includes(paymentMode)
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length === 0) {
        return myDate <= new Date(endDate) && orderTime >= startTime && orderTime <= endTime
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length > 0) {
        return myDate <= new Date(endDate) && orderTime >= startTime && payment.includes(paymentMode)
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length === 0) {
        return myDate <= new Date(endDate) && orderTime >= startTime
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length > 0) {
        return myDate <= new Date(endDate) && orderTime <= endTime && payment.includes(paymentMode)
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length === 0) {
        return myDate <= new Date(endDate) && orderTime <= endTime
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length > 0) {
        return myDate <= new Date(endDate) && payment.includes(paymentMode)
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length === 0) {
        return myDate <= new Date(endDate)
      } else if (startDate.length === 0 && endDate.length === 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length > 0) {
        return payment.includes(paymentMode)
      } else if (startDate.length === 0 && endDate.length === 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length === 0) {
        return orderTime >= startTime
      } else if (startDate.length === 0 && endDate.length === 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length === 0) {
        return orderTime <= endTime

      }else if(startDate.length === 0 && endDate.length === 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length === 0 ){
        return orderTime >= startTime && orderTime <= endTime
      } else {
        return true
      }
    }
    )
    setorder(filteredData)
    setModalShow1(false);
    setstartDate("");
    setendDate("");
    setstartTime("");
    setendTime("");
    setpaymentMode("");

  }
  const print = async () => {
    const elementToCapture = document.getElementById('receiveprint');
    elementToCapture.style.width = "100%"; // Adjust the width
    elementToCapture.style.height = "auto";

    // Use html2pdf to convert the element to a PDF
    await html2pdf(elementToCapture)
      .then(async (pdf) => {
        // You can then save the PDF or perform other actions
        // For example, to save the PDF:
        await pdf.save("order.pdf");

      })
      .catch(error => {
        console.error('Error converting element to PDF:', error);
      });
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Change as per your requirement

  // Get current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = order.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getOrderIndex = (id) => {
    const index = order.findIndex((order) => order.OrderId === id);
    setindex(index);
  }

  const updateStatus = async () => {
    await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminCancelOrder`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: JSON.stringify({
            OrderId: order[0].OrderId,
            OrderStatus: "Cancelled",
            ShipRocket: order[0].ShipRocket,
        })

    }).then((res) => res.json()).then((response) => {


        if (response.status === 200) {
            setLgShow2(false)
            getreceivedorder()
            toast.success(response.message)

        } else {
            toast.error(response.message)
        }
    }).catch((err) => {
        console.log(err)
    })

}
  const refreshData = async () => {
    // Clear search input
    setsearchvalue("");
    // Reset to original data from API
    await getreceivedorder();
    // Reset page
    setCurrentPage(1);
    // Reset filter values
    setstartDate("");
    setendDate("");
    setstartTime("");
    setendTime("");
    setpaymentMode("");
    toast.success("Data refreshed successfully");
  }
  return (
      <section className="dashbg-color">

        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="admin-filters">

              <div className="search-bar">
                <div className="search-container">
                  <form action="">
                    <input type="text" placeholder="Search by- OrderId, Phone" name="search" value={searchvalue} onChange={(e) => {
                      setsearchvalue(e.target.value)
                      // Auto-reset when input is cleared
                      if (e.target.value === '') {
                        setorder(originalOrder)
                        setCurrentPage(1)
                      }
                    }} />
                    <button type="button" onClick={() => {
                      search()
                    }}><i className="fa fa-search"></i></button>
                  </form>
                </div>
              </div>

              <div className="filters">
                <button className="btn filter-pop" onClick={() => {
                  setModalShow1(true);
                }}>Filters <i className="fa fa-filter"></i></button>
                <button className="btn Export-btn filter-pop" onClick={() => {
                  handleExportCSV();
                  toast.success("CSV downloaded successfully")
                }}>Export CSV <i className='fas fa-file-export'></i></button>
                <button className="btn filter-pop ml-2" style={{ backgroundColor: "white", color: "#4CAF50", borderColor:"#4CAF50" }} onClick={refreshData}>
                   <i className="fas fa-sync-alt"></i>
                </button>
              </div>

            </div>
          </div>

        </div>

        <div className="row justify-content-center">
          <div className="col-lg-12 table-bg">
            <div style={{ backgroundColor: "white" }}>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">Order ID</th>
                      <th scope="col">Product Name</th>
                      <th scope="col">Buyer</th>
                      <th scope="col">Date</th>
                      <th scope="col">Time</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Payment</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Discount</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 && currentItems.map((item, index) => {
                      let totalQuantity = 0;
                      let totalSubTotal = 0;


                      item.OrderDetail.forEach((orderDetailItem) => {
                        totalQuantity += parseInt(orderDetailItem.OrderQuantity);
                        totalSubTotal += parseInt(orderDetailItem.OrderSubTotal);

                      });

                      return (
                        <tr key={index}>
                          <th scope="row">{index + indexOfFirstItem + 1}</th>
                          <td>{item.OrderId}</td>
                          <td>{item.OrderDetail[0].OrderName} {item.OrderDetail.length > 1 ? "+ " + parseInt(item.OrderDetail.length - 1) : ""}</td>
                          <td>{item.UserPhone}</td>
                          <td>{item.OrderDate.split(" ")[0]}</td>

                          <td>{item.OrderDate.split(" ")[1]}</td>
                          <td>{totalQuantity}</td>
                          <td>{item.OrderPaymentType}</td>
                          <td>{totalSubTotal - parseInt(item.OrderCoupanPrice)}</td>
                          <td>{parseInt(item.OrderCoupanPrice)}</td>
                          <td>{item.OrderConfirmedStatus !== "Cancelled"?<div >{item.OrderConfirmedStatus === "Confirmed" ? <button className="btn receive-btn" onClick={() => {
                            getOrderIndex(item.OrderId)
                            setModalShow(true);
                            setid(item.OrderId)

                          }}>Received <i className='fas fa-long-arrow-alt-right'></i></button> : <button className="btn shipped-btn" onClick={() => {


                            updateshippedorder("Shipped", item.OrderId)
                          }}>Ship Now  <i className='fas fa-long-arrow-alt-right'></i></button>}

                          <button className='btn btnsubmitlog' onClick={()=>{
                             getOrderIndex(item.OrderId)
                             setLgShow2(true)
                          }}> Cancel</button>
                          </div>:""}

                         
                          </td>
                        </tr>
                      )
                    })}
                    {currentItems.length === 0 && <tr>
                      <td colSpan="11" className="text-center">No Order Found</td>
                    </tr>}







                  </tbody>
                </table>
              </div>



              <div className="row">
                <div className="col-lg-12 text-center" style={{ position: "relative" }}>
                  <div className="pagination pagi">
                    {currentPage === 1?"":<a href="javascript:void(0)" onClick={prevPage} disabled={currentPage === 1}>&laquo;</a>}

                    {Array.from({ length: Math.ceil(order.length / itemsPerPage) }).map((_, index) => (
                      <a href="javascript:void(0)" key={index}
                        onClick={() => goToPage(index + 1)}
                        className={currentPage === index + 1 ? "active" : ""}>{index + 1}</a>
                    ))}
                   {currentPage === Math.ceil(order.length / itemsPerPage)?"": <a href="javascript:void(0)" onClick={nextPage}
                      disabled={currentPage === Math.ceil(order.length / itemsPerPage)}>&raquo;</a>}

                  </div>
                  <div className="table-no-count">
                    Showing {Math.min(indexOfLastItem, order.length)} of {order.length} results
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"

                    centered
                    show={lgShow2}

                    onHide={() => setLgShow2(false)}

                >
                    <Modal.Header closeButton style={{ borderBottom: "none", padding: "1rem 1rem 0rem 0rem" }}>

                    </Modal.Header>
                    <Modal.Body style={{ paddingTop: "0rem" }}>


                        <div className="box-profile-pop-profile">



                            <div className="logoutpop">
                                <img src="assets/Vector.svg" className="img-fluid" alt="exlam" />
                            </div>
                            <div className="logoutpop mt-2">
                                <p>Are you sure you want to cancel the order?</p>
                            </div>

                            

                            <div className="logoutpop button">
                                <button className="btn btncancellog" onClick={() => setLgShow2(false)}>
                                    No
                                </button>
                                <button className="btn btnsubmitlog" onClick={() => {
                                    updateStatus()
                                }}>Yes</button>
                            </div>







                        </div>


                    </Modal.Body>
                </Modal>
        <Modal
          show={modalShow}
          size="xl"
         
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header style={{ padding: "0px" }}>
            <div className="row topbox p-1">
              <div className="col-lg-12 d-flex justify-content-between">
                <div className="col-sm-2 img">
                  <img src="./assets/print.svg" style={{
                    cursor: "pointer"
                  }} onClick={() => {
                    print()
                  }} />
                </div>
                <div className="col-sm-2" >
                  {index !== null?<h2>{order?.length > 0 ? order?.[index].OrderId : ""}</h2>:""}
                </div>
                <div className="col-sm-2 " style={{ alignItems: "center" }} >

                  <img className="" src="./assets/cross.svg" alt="" width="50px" height="50px" style={{ cursor: "pointer" }} onClick={() => {
                    setModalShow(false);
                    setindex(0)

                  }} />
                </div>
              </div>
            </div>

          </Modal.Header>
          <Modal.Body>
            {index !== null?<div id='receiveprint'>
              <div className="row content d-flex p-1 mt-3 mb-3" >
                <div className="col-lg-12 d-flex justify-content-between">
                  <div className="left-cntnt">
                    <div className="input-box">
                      <span className="details">Order ID:</span>
                      <span>{order.length > 0 ? order[index].OrderId : ""}</span>
                    </div>
                    <div className="input-box">
                      <span className="details">Name :</span>
                      <span>{order.length > 0 ? <>{order[index].OrderAddress?.[0]?.FirstName} {order[index].OrderAddress?.[0]?.LastName}</> : ""}</span>
                    </div>
                    <div className="input-box">
                      <span className="details">Phone:</span>
                      <span>{order.length > 0 ? order[index].OrderAddress?.[0]?.Phone : ""}</span>
                    </div>
                    <div className="input-box">
                      <span className="details">GSTIN No.</span>
                      <span>{order[index]?.OrderGST}</span>
                    </div>
                    <div className="input-box">
                      <span className="details">PaymentMode:</span>
                      <span>{order[index]?.OrderPaymentType}</span>
                    </div>

                  </div>
                  <div className="right-cntnt">
                    <div className="input-box">
                      <span className="details">Date:</span>
                      <span>{order.length > 0 ? order[index].OrderDate : ""}</span>
                    </div>
                    <div className="input-box">
                      <span className="details">Address:</span>
                      <span>{order.length > 0 ? <>{order[index].OrderAddress?.[0]?.Address} {order[index].OrderAddress?.[0]?.Address1}</> : ""}</span>
                    </div>
                    <div className="input-box">
                      <span className="details">State:</span>
                      <span>{order.length > 0 ? order[index].OrderAddress?.[0]?.State : ""}</span>
                    </div>
                    <div className="input-box">
                      <span className="details">Pin Code.</span>
                      <span>{order.length > 0 ? order[index].OrderAddress?.[0]?.Pincode : ""}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 table-bg ">
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col" className='tableheadwidth'>S.No</th>
                          <th scope="col" className='tableheadwidth'>Item No.</th>
                          <th scope="col">Product Name</th>
                          <th scope="col" className='tableheadwidth'>Quantity</th>
                          <th scope="col">Sweep Size</th>
                          <th scope="col" className='tableheadwidth'>Colour</th>
                          <th scope="col" className='tableheadwidth'>Price incl GST</th>
                        </tr>
                      
                      </thead>
                      <tbody>
                        {order.length > 0 && order[index].OrderDetail.map((item, index) => {
                          return (
                            <>
                              <tr key={index}>
                                <th scope="row" className='tableheadwidth'>{index + 1}</th>
                                <td className='tableheadwidth'>{item.OrderItemId}</td>
                                <td>{item.OrderName}</td>
                                <td className='tableheadwidth'>{item.OrderQuantity}</td>
                                <td className='tableheadwidth'>{item.OrderSize}</td>
                                <td className='tableheadwidth'>{item.OrderColor}</td>
                                <td className='tableheadwidth'>{item.OrderSubTotal}</td>
                              </tr>
                            
                            </>
                          )
                        })
                        }


                      </tbody>
                     
                    </table>
                  </div>
                </div>
              </div>
            </div>:""}


            <div className="apply-btn mt-4 align-content-center">
              <img src="assets/applybtn.svg" alt="" onClick={() => {

                updateorder("Received")

              }} />
            </div>
          </Modal.Body>

        </Modal>
        <Modal
          show={modalShow1}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header style={{ padding: "0px" }}>

            <div className="title m-0 p-0">
              <h3 className="p-3">Filters</h3>
            </div>
          </Modal.Header>
          <Modal.Body>
            <form className="mt-3 p-3">
              <div className="filter-dt p-2">
                <div className="input-box">
                  <span className="details">Start Date</span>
                  <input type="date" className="form-control" placeholder="dd/mm/yyyy" required value={startDate} onChange={(e) => {
                    setstartDate(e.target.value)
                  }} />
                </div>
                <div className="input-box">
                  <span className="details">End Date</span>
                  <input type="date" className="form-control" placeholder="dd/mm/yyyy" required value={endDate} onChange={(e) => {
                    setendDate(e.target.value)
                  }} />
                </div>
                <div className="input-box">
                  <span className="details">Start Time</span>
                  <input type="time" className="form-control" placeholder="12:46 AM" required value={startTime} onChange={(e) => {
                    setstartTime(e.target.value)

                  }} />
                </div>
                <div className="input-box">
                  <span className="details">End Time</span>
                  <input type="time" className="form-control" placeholder="12:46AM" required value={endTime} onChange={(e) => {
                    setendTime(e.target.value)

                  }} />
                </div>
                <div className="payment-method mb-2">
                  <div className="details m-1">Payment Mode</div>
                  <select className="form-control p-2" value={paymentMode} onChange={(e) => {
                    setpaymentMode(e.target.value)
                  }}>
                    <option value={""}>Payment Type</option>
                    <option value={"COD"}><div className="check-box p-1">
                      <input type="checkbox" />
                      <label for="">COD</label>
                    </div></option>
                    <option value={"Prepaid"}><div className="check-box p-1">
                      <input type="checkbox" />
                      <label for="">Prepaid</label>
                    </div></option>
                  </select>


                </div>

              </div>
            </form>
            <div className="buton mb-3 d-flex align-content-end justify-content-end p-3 pl-5">
              <button className="btn1" onClick={() => {
                setModalShow1(false);
                getreceivedorder();
                setstartDate("");
                setendDate("");
                setstartTime("");
                setendTime("");
                setpaymentMode("");

              }}>Cancel</button> &nbsp;&nbsp;
              <button className="btn2 " onClick={() => {
                filter()
              }}>Apply</button>
            </div>



          </Modal.Body>

        </Modal>




      </section>
  )
}
export default Recived_orders;